import WeekTickFormatter from './component';

export default WeekTickFormatter;
